import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sortByCreated } from '../../../Services/sortByCreated';
import { saleByStoreAsync } from './services';
import { ISalesByStore } from './interface';


interface InitialState {
  value: IDashboardState;
}

interface StateForm {
  state: "error" | "loading" | "send" | "default";
  message?: string;
}

interface IDashboardState {
  loading: boolean;
  fetchError: string | {};
  stateForm: StateForm;
  salesByStore: ISalesByStore[];
}

const initialState: InitialState = {
  value: {
    loading: false,
    fetchError: "",
    stateForm: { state: "default" },
    salesByStore:[]
  } as IDashboardState,
};

export const dashboardState = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setStateForm: (state: InitialState, action: PayloadAction<StateForm>) => {
      state.value.stateForm = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<InitialState>) => {
    builder.addCase(saleByStoreAsync.pending, (state: InitialState) => {
      state.value.loading = true;
    });
    builder.addCase(
      saleByStoreAsync.fulfilled,
      (state: InitialState, action: PayloadAction<ISalesByStore[]>) => {
        state.value.loading = false;
        state.value.salesByStore = sortByCreated([...action.payload]);
      },
    );
    builder.addCase(saleByStoreAsync.rejected, (state: InitialState, action) => {
      state.value.loading = false;
      state.value.fetchError = action.payload ?? "Error fetching user data";
    });
  },
});

export const { setStateForm } = dashboardState.actions;

export default dashboardState.reducer;
